// libs
import { styled } from '@nykaa/ui-components';

// mixins
import { getColumnDimension } from 'shared/components/AdPlatformWidgets/Desktop/mixin';

export const TextLink = styled.a<{ numOfColumns: number; align: string }>`
  height: 40px;
  display: inline-block;
  ${({ theme }) => theme.typography.bodyLarge};
  text-transform: capitalize;
  padding: ${({ theme }) => theme.spacing.spacing60};
  text-decoration: none;
  border: 1px solid #ebebeb;
  border-radius: ${({ theme }) => theme.borders.radius20};
  margin: ${({ theme }) => `0 ${theme.spacing.spacing50} ${theme.spacing.spacing50} 0`};

  ${({ numOfColumns }) => getColumnDimension(numOfColumns)}

  ${(props) => `text-align: ${props.align}`}
`;
